export default "__VITE_ASSET__DNTjvlcj__"